import React, {useRef} from "react";
import {AutoSizer, Grid, WindowScroller} from "react-virtualized";
import PropTypes from "prop-types";

import {navItemInterface} from "../../../../interfaces/featureInterface";
import ShopCategoryListFeature from "./shopCategoryListFeature";


const ShopCategoryVirtualizedGrid = (props) => {

  const {renderList, windowWidth, scrollElement, isMobile, onScrollHandler} = props;
  const listElement = useRef();

  const featureHeight = isMobile ? 200 : 320;
  const gridColumnCount = windowWidth < 768 ? 3 : 4;

  const featureWidth = isMobile ? (windowWidth - 20) / gridColumnCount : 250;

  const gridRowCount = Math.ceil(renderList.length / gridColumnCount);
  // const gridColumnWidth = windowSize.width < 1024 ? windowSize.width - 32 : FEATURE_WIDTH;
  // console.log("gridColumnCount", gridColumnCount);
  // console.log("gridRowCount", gridRowCount);
  // console.log("gridColumnWidth", gridColumnWidth);

  const gridItemRenderer = ({columnIndex, key, rowIndex, style}) => {
    let index = (gridColumnCount * rowIndex) + columnIndex;
    let navItem = renderList[index];
    if (!navItem) {
      return null
    }
    return (
      <div style={style} key={key}>
        <ShopCategoryListFeature navItem={navItem} />
      </div>
    )
  }


  const overscanIndicesGetter = ({
                                   // direction, // One of "horizontal" or "vertical"
                                   cellCount, // Number of rows or columns in the current axis
                                   // scrollDirection, // 1 (forwards) or -1 (backwards)
                                   overscanCellsCount, // Maximum number of cells to over-render in either direction
                                   startIndex, // Begin of range of visible cells
                                   stopIndex, // End of range of visible cells
                                 }) => {
    return {
      overscanStartIndex: Math.max(0, startIndex - overscanCellsCount),
      overscanStopIndex: Math.min(cellCount - 1, stopIndex),
    };
  }

  return (
    <div className="shop-list" ref={listElement}>
      <WindowScroller scrollElement={scrollElement}>
        {({height, scrollTop}) => height ? (
          <AutoSizer disableHeight>
            {() => (
              <Grid
                autoHeight
                onScroll={onScrollHandler}
                cellRenderer={gridItemRenderer}
                columnCount={gridColumnCount}
                columnWidth={featureWidth}
                width={featureWidth * gridColumnCount}
                height={height}
                rowCount={gridRowCount}
                rowHeight={featureHeight}
                overscanRowCount={1}
                scrollTop={scrollTop}
                overscanIndicesGetter={overscanIndicesGetter} // this prevents hiding top row on scroll down beforehand
              />
            )}
          </AutoSizer>
        ) : null}
      </WindowScroller>
    </div>
  )
};

ShopCategoryVirtualizedGrid.propTypes = {
  renderList: PropTypes.arrayOf(PropTypes.shape(navItemInterface)),
  scrollElement: PropTypes.oneOfType([PropTypes.func, PropTypes.node, PropTypes.instanceOf(Element)]),
  onScrollHandler: PropTypes.func,
}

export default ShopCategoryVirtualizedGrid
